var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-item",style:({
		..._vm.styleObj
	})},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"item-content"},[(_vm.treeData && _vm.treeData.length)?[_c('ArchiTree',{attrs:{"treeData":_vm.treeData}})]:_c('el-empty',{attrs:{"description":"暂无数据","image-size":80}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }